import './App.css';
import Navbar from './components/Navbar';
import React, { useState, useContext, useEffect } from 'react';
import Home from './components/Home';
import Changes from './components/Changes';
import Subscriptions from "./components/Subscriptions.jsx";
import SubscriptionManagement from "./components/SubscriptionManagement.jsx";
import TestResults from "./components/TestResults.jsx";
import ChangeDetailsPage from "./components/ChangeDetailsPage.jsx";
import ApplicationOnboarding from "./components/ApplicationOnboarding.jsx";
import P1P2Incidents from "./components/P1P2Incidents.jsx";
import RedGreenChannelTracker from "./components/RedGreenChannelTracker";
import { loginRequest } from './authConfig';
import { callMsGraph } from './graph';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated, useMsal, useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from "@azure/msal-browser";
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import { TableContext } from "./context";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from './components/Footer';

/**
 * Main application component.
 * Handles authentication, routing, and global state management.
 */
function App() {
  // Initiate MSAL authentication using redirect interaction type
  useMsalAuthentication(InteractionType.Redirect);

  // Extract context values from TableContext
  const { graphData, setGraphData, tokenFetched, setTokenFetched, getToken, getTableData, fetchUserDetails, loading } = useContext(TableContext);
  
  // Local state variables
  const [progress, setProgress] = useState(0);
  const [open, setOpen] = useState(false);
  const [run, setRun] = useState(false);

  /**
   * Closes the modal.
   */
  const handleClose = () => {
    setOpen(false);
  };

  /**
   * Opens the modal.
   */
  const handleOpen = () => {
    setOpen(true);
  };

  // Effect to fetch token when graphData is available
  


  return (
    <>
      <AuthenticatedTemplate>
        <Router>
          <ToastContainer
            position="top-center" // Set the position of the toast container
            autoClose={3000} // Automatically close toasts after 3 seconds
            hideProgressBar={false} // Display the progress bar
            closeOnClick={true} // Close toasts on click
            pauseOnHover={true} // Pause toast animation on hover
            draggable={true}
            closeButton={true} // Allow toasts to be dragged
            theme="light" // Use the light theme
          />

          <Navbar setRun={setRun} run={run} graphData={graphData} />
          <Routes>
            <Route
              exact
              path="/home"
              element={<Home setProgress={setProgress} graphData={graphData} setOpen={setOpen} setRun={setRun} run={run} />}
            />
            <Route exact path="/" element={<Navigate to="/home" replace />} />
            <Route exact path="/Changes" element={<Changes setProgress={setProgress} />} />
            <Route exact path="/P1P2Incidents" element={<P1P2Incidents setProgress={setProgress} />} />
            <Route exact path="/RedGreenChannelTracker" element={<RedGreenChannelTracker setProgress={setProgress} />} />
            <Route exact path="/Subscriptions" element={<Subscriptions setProgress={setProgress} />} />
            <Route exact path="/subscription-management" element={<SubscriptionManagement />} />
            <Route exact path="/TestResults" element={<TestResults setProgress={setProgress} />} />
            <Route exact path="/change_details" element={<ChangeDetailsPage />} />
            <Route exact path="/application-onboarding" element={<ApplicationOnboarding setProgress={setProgress} />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </Router>
        <Footer />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <h1>Authenticating...</h1>
        </div>
      </UnauthenticatedTemplate>
    </>
  );
}

export default App;